module.exports = __webpack_public_path__ + "static/assets/626fc5391c3e6b027400d4e63831a808.svg";